import ConfirmPhoneView   from "./confirm-phone";
import ContactsView       from "./contacts";
import DateView           from "./date";
import DoctorView         from  "./doctor";
import ReceiptView        from "./receipt";
import ServiceView        from "./service";
import TimeView           from "./time";
import BranchView         from "./branch";
import BookingView        from "./booking";
import ConfirmBookingView from "./confirm-booking";
import TagsView           from "./tags";
import StartView          from "./start";

export default {
    ConfirmPhoneView,
    ContactsView,
    DateView,
    DoctorView,
    ReceiptView,
    ServiceView,
    TimeView,
    BranchView,
    BookingView,
    ConfirmBookingView,
    TagsView,
    StartView,
};


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/index.js
 **/